import { Group } from '@mantine/core'
import React from 'react'
import XIcon from './../../components/XIcon'
import FacebookIcon from './../../components/FacebookIcon'
import LinkedInIcon from './../../components/LinkedInIcon'
import InstagramIcon from './../../components/InstagramIcon'
import YoutubeIcon from './../../components/YoutubeIcon'

/**
 * Renders a list of all available social media links for a company.
 * @param {object} socialMedia The list of social media links.
 * @param {string} color The text color for the links.
 * @returns {JSX.Element}
 */
function SocialMedia ({ socialMedia, color }) {
  return (
    <Group>
      { socialMedia.x_url && <XIcon url={socialMedia.x_url} color={color} /> }
      { socialMedia.facebook_url && <FacebookIcon url={socialMedia.facebook_url} color={color} /> }
      { socialMedia.linkedin_url && <LinkedInIcon url={socialMedia.linkedin_url} color={color} /> }
      { socialMedia.instagram_url && <InstagramIcon url={socialMedia.instagram_url} color={color} /> }
      { socialMedia.youtube_url && <YoutubeIcon url={socialMedia.youtube_url} color={color} /> }
    </Group>
  )
}

export default React.memo(SocialMedia)
